import { createFileRoute } from '@tanstack/react-router'
import { StockTransferDetailPage } from '../../../../features/inventory/stock-transfer-pages'

export const Route = createFileRoute('/_app/stock-transfers/$transferId/')({
  component: StockTransferDetailPage,
})
